import * as Immutable from 'immutable'
import * as UrlHelpers from 'url'
import { HttpResult } from 'widgets-for-react'
import { getCsrfToken } from '../../../utils/csrf'
import { prefixUrlWithLocale } from '../../../utils/url'
import {
  ContentAuditSuspect,
  ContentAuditSuspectUser,
  PagedContentAuditSuspects,
  SuspectsFilter,
  TypeFilterMapping
} from './contentAuditSuspectsState'

export async function getSuspects(
  filter: SuspectsFilter,
  page: number
): Promise<HttpResult<PagedContentAuditSuspects>> {
  const res = await fetch(
    prefixUrlWithLocale(
      `/api/superadmin/content_audit_suspects${UrlHelpers.format({
        query: {
          page,
          status: filter.status.v.kind === 'r' ? filter.status.v.v : null,
          booking_adverts: filter.booking_adverts ? 1 : null,
          published_adverts: filter.published_adverts ? 1 : null,
          type: Immutable.Map(filter.type)
            .filter((v, _) => v)
            .map((_, k) => TypeFilterMapping()[k])
            .toList()
            .flatMap(x => x)
            .join(',')
        }
      })}`
    )
  )
  if (!res.ok) {
    return { kind: 'failed', status: res.status }
  }

  return {
    kind: 'result',
    value: await res.json(),
    status: 200
  }
}

export type MarkAsNoViolationResponse = {
  status: 'no_violation'
}
export type MarkAsViolationResponse = {
  status: 'violation'
}

export async function markSuspectAsViolation(
  suspect: ContentAuditSuspect,
  strike: boolean
): Promise<HttpResult<MarkAsViolationResponse>> {
  const res = await fetch(
    prefixUrlWithLocale(
      `/api/superadmin/content_audit_suspects/${suspect.id}/mark_as_violation`
    ),
    {
      method: 'put',
      body: JSON.stringify({
        strike: strike ? 1 : null
      }),
      headers: [
        ['Content-Type', 'application/json'],
        ['Accept', 'application/json'],
        ['X-CSRF-Token', getCsrfToken()]
      ]
    }
  )
  if (!res.ok) {
    return { kind: 'failed', status: res.status }
  }

  return {
    kind: 'result',
    value: await res.json(),
    status: 200
  }
}

export async function markSuspectAsNoViolation(
  suspect: ContentAuditSuspect
): Promise<HttpResult<MarkAsNoViolationResponse>> {
  const res = await fetch(
    prefixUrlWithLocale(
      `/api/superadmin/content_audit_suspects/${suspect.id}/mark_as_no_violation`
    ),
    {
      method: 'put',
      headers: [
        ['Content-Type', 'application/json'],
        ['Accept', 'application/json'],
        ['X-CSRF-Token', getCsrfToken()]
      ]
    }
  )
  if (!res.ok) {
    return { kind: 'failed', status: res.status }
  }

  return {
    kind: 'result',
    value: await res.json(),
    status: 200
  }
}

export async function getContentAuditSuspectUser(
  suspect: ContentAuditSuspect
): Promise<HttpResult<ContentAuditSuspectUser>> {
  const res = await fetch(
    prefixUrlWithLocale(
      `/api/superadmin/content_audit_suspects/${suspect.id}/user`
    )
  )
  if (!res.ok) {
    return { kind: 'failed', status: res.status }
  }

  return {
    kind: 'result',
    value: await res.json(),
    status: 200
  }
}
